import { type ReactNode } from 'react'
import type { TenantAnalytics } from '@/lib/apiTypes'
import { formatCount } from '@/lib/format'

/**
 * Inventory grid beneath the resource/storage split: counts of modules, providers,
 * and retained versions, plus the live state-file (workspace) count. Storage totals
 * moved to the dedicated StorageBar, so they're intentionally not repeated here.
 * `stateFilesCount` is the live-workspace count (one state file per workspace);
 * undefined on an older worker, in which case the cell is hidden rather than shown
 * as a misleading 0.
 */
export function FootprintSummary({
  footprint,
  stateFilesCount,
}: {
  footprint: TenantAnalytics['footprint'] | undefined
  stateFilesCount: number | undefined
}) {
  if (!footprint) return null
  const fp = footprint
  const cell = (label: string, value: ReactNode) => (
    <div key={label}>
      <div className="footprint-inv-num">{value}</div>
      <div className="footprint-inv-label">{label}</div>
    </div>
  )
  return (
    <div className="footprint-inventory">
      {cell('modules', formatCount(fp.module_count))}
      {cell('providers', formatCount(fp.provider_count))}
      {cell('module versions', formatCount(fp.module_versions_retained))}
      {cell('state versions', formatCount(fp.state_versions_retained))}
      {stateFilesCount !== undefined && cell('state files', formatCount(stateFilesCount))}
    </div>
  )
}

